import { render, staticRenderFns } from "./VentaModalPerseo.vue?vue&type=template&id=96652bd0&scoped=true"
import script from "./VentaModalPerseo.vue?vue&type=script&lang=js"
export * from "./VentaModalPerseo.vue?vue&type=script&lang=js"
import style0 from "./VentaModalPerseo.vue?vue&type=style&index=0&id=96652bd0&prod&scoped=true&lang=css"
import style1 from "./VentaModalPerseo.vue?vue&type=style&index=1&id=96652bd0&prod&scoped=true&lang=css"
import style2 from "./VentaModalPerseo.vue?vue&type=style&index=2&id=96652bd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96652bd0",
  null
  
)

export default component.exports